import React, { Fragment } from 'react'
import DropDown from './DropDown'
import CutToSizeThicknessSelection from './ThicknessSelection'
import SizeInput from './SizeInput'
import { CutToSizeGroupModel, CutToSizeLogicModel } from './types/models'

type Props = {
  groups: CutToSizeGroupModel[]
  cutToSizeLogic: CutToSizeLogicModel
}

const MobileGrid = ({ groups, cutToSizeLogic }: Props): React.JSX.Element => {
  return (
    <>
      <div className='cuttingTool-groupCell'>
        { groups.length > 1
          ? (<DropDown values={groups.map((ctg) => ctg.name)} onValueChange={cutToSizeLogic.onGroupChange} value={cutToSizeLogic.currentGroup.name} />)
          : (<p>{cutToSizeLogic.currentGroup.name}</p>)
        }
      </div>

      { !cutToSizeLogic.hasProducts() &&
        <>
          <div>
            <p>This product is not available at the moment</p>
          </div>

          <div>
          </div>
        </>
      }

      { cutToSizeLogic.hasProducts() && cutToSizeLogic.usesSize() &&
        <>
          <div>
            <p>Size</p>
          </div>

          <div>
            <DropDown values={cutToSizeLogic.sortArray(Object.keys(cutToSizeLogic.currentGroup.dimensions))} onValueChange={cutToSizeLogic.onDimensionChange} value={cutToSizeLogic.selectedDimension} />
          </div>
        </>
      }

      { cutToSizeLogic.hasProducts() && cutToSizeLogic.usesThickness() &&
        <>
          <div>
            <p>Thickness</p>
          </div>

          <div>
            {CutToSizeThicknessSelection({
              validThicknesses: cutToSizeLogic.validThicknesses,
              onThicknessChange: cutToSizeLogic.onThicknessChange,
              selectedThickness: cutToSizeLogic.selectedThickness
            })
            }
          </div>
        </>
      }

      {
        cutToSizeLogic.hasProducts() && cutToSizeLogic.constraints.map((constraint) => {
          const isLength = constraint.field === cutToSizeLogic.LENGTH
          return (
            <Fragment key={`${cutToSizeLogic.selectedProduct?.name}-${constraint.field}-input-mobile`}>
              <div>
                <p>{ constraint.field }</p>
              </div>

              <div className='cuttingTool-sizeInput'>
                <SizeInput
                  sizeConstraint={constraint}
                  unit={isLength ? cutToSizeLogic.unitForLength : cutToSizeLogic.unitForWidth}
                  value={isLength ? cutToSizeLogic.length : cutToSizeLogic.width}
                  valid={cutToSizeLogic.calculateValidSize(isLength)}
                  min={isLength ? cutToSizeLogic.lengthMin : cutToSizeLogic.widthMin}
                  max={isLength ? cutToSizeLogic.lengthMax : cutToSizeLogic.widthMax}
                  step={isLength ? cutToSizeLogic.lengthStep : cutToSizeLogic.widthStep}
                  onSizeChange={cutToSizeLogic.onSizeChange}
                  onUnitChanged={cutToSizeLogic.onUnitChanged}
                />
              </div>
            </Fragment>
          )
        })
      }

      {
        cutToSizeLogic.selectedProduct && cutToSizeLogic.pricingOption && cutToSizeLogic.pricingOption.originalPrice &&
          <div className='cuttingTool-priceExVat'>
            <p>Was (Ex VAT)</p>
          </div>
      }

      {
        cutToSizeLogic.selectedProduct && cutToSizeLogic.pricingOption && cutToSizeLogic.pricingOption.originalPrice &&
        <div className='cuttingTool-priceExVat'>
          <span className="on-offer">on offer</span>
          <p className='prev-price'>£{cutToSizeLogic.originalPrice.toFixed(2)}</p>
        </div>
      }

      <div className='cuttingTool-priceExVat'>
        <p>Price (Ex VAT)</p>
      </div>

      <div className='cuttingTool-priceExVat'>
        <p>£{cutToSizeLogic.price.toFixed(2)}</p>
      </div>

      <div className='cuttingTool-priceIncVat'>
        <p>Price (Inc VAT)</p>
      </div>

      <div className='cuttingTool-priceIncVat'>
        <p>£{(cutToSizeLogic.price * cutToSizeLogic.VAT_RATE).toFixed(2)}</p>
      </div>

      <div>
        <p>Quantity</p>
      </div>

      <div>
        <input
          className='qty-input customCutting-field cuttingTool-quantityField'
          type='number'
          step='1'
          min='0'
          max='999'
          value={cutToSizeLogic.quantity || ''}
          autoComplete='off'
          onChange={cutToSizeLogic.onQuantityChanged}/>
      </div>
    </>
  )
}

export default MobileGrid
